// Eén categorielijst voor Inspiratie en Video Search, in de taal van de
// Gripp-projecttypes. De engine heeft dezelfde lijst in
// ai-engine/services/categorieen.py — een test bewaakt dat ze gelijk blijven.
export const VIDEO_CATEGORIEEN = [
  'Bedrijfsfilm', 'Projectfilm', 'Productfilm', 'Commercial', 'Testimonial', 'Explainer', 'Interview', 'Eventfilm', 'Registratie', 'Animatie', 'Podcast', 'Webinar', 'Documentaire', 'Social media', 'Music video', 'Aftermovie', 'Overig',
];
export const CATEGORIE_OVERIG = 'Overig';
/** Toon de categorie alleen als hij iets zegt. */
export const toonCategorie = (c) => Boolean(c) && c !== 'Overig' && c !== 'Other';
